import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  Box,
  Container,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import { Seo } from "src/components/seo";

const PaymentFailed: React.FC = () => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { state } = useLocation();
  const error = state?.error;
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(error);
    setCopied(true);
  };

  return (
    <>
      <Seo title="Payment Failed" />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
            pb: "120px",
            height: mdUp ? undefined : "auto",
            flexGrow: 1,
            py: 12,
          }}
        >
          <Container maxWidth="md">
            <Stack
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                pb: 5,
                mx: 2,
              }}
              spacing={2}
            >
              <ErrorOutlineIcon
                sx={{
                  fontSize: 64,
                  color: theme.palette.error.main,
                }}
              />
              <Typography
                variant="h3"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mt: 2,
                  mb: 2,
                  color: theme.palette.error.main,
                }}
              >
                {"Payment Failed"}
              </Typography>
              <Stack>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {
                    "Unfortunately, your payment was not successful. Please try again or use a different payment method."
                  }
                </Typography>
                {error && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        mb: 2,
                        color: theme.palette.error.main,
                        bgcolor: theme.palette.background.default,
                        p: 2,
                        borderRadius: 1,
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      Error details: {error}{" "}
                      <Tooltip title={copied ? "Copied!" : "Copy error"}>
                        <IconButton
                          size="small"
                          onClick={handleCopy}
                          sx={{ mt: 1 }}
                        >
                          {copied ? (
                            <CheckIcon fontSize="small" />
                          ) : (
                            <ContentCopyIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Typography>
                  </Box>
                )}
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {
                    "If you continue to experience issues, please don't hesitate to reach out to us via "
                  }{" "}
                  <Link
                    href="https://wa.me/31639202608"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {"WhatsApp"}
                  </Link>{" "}
                  {"or"}{" "}
                  <Link
                    href="mailto: info@opensource.clinic"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {"Email"}
                  </Link>
                  {"."}
                </Typography>
              </Stack>
            </Stack>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default PaymentFailed;
